module.exports = __webpack_public_path__ + "static/media/Project-Production.90736b22.svg";